import _ from "lodash";

export const mergeChangesWithData = ({ data, updated, removed, added }) => {
  const addedArray = Array.from(added.values());

  return _.chain(data)
    .map(({ grade, ...rest }) => {
      const { id } = grade;
      const isRemoved = removed.has(id);
      if (isRemoved) return null;

      const gradeChanges = updated.get(id) || {};
      const originalGradingPeriods = _.get(rest, "gradingPeriods", []);

      return {
        ...rest,
        originalGradingPeriods,
        grade,
        ...gradeChanges,
      };
    })
    .compact()
    .concat(addedArray)
    .sortBy("displaySequence")
    .value();
};

export const buildRemovedGradeMappings = allRemoved => {
  const removed = [];

  allRemoved.forEach((removedSet, studentId) => {
    removedSet.forEach(gradeId => {
      removed.push({ studentId, gradeId });
    });
  });

  return removed;
};

export const buildAddedGradeMappings = studentWiseData => {
  const added = [];

  _.forEach(studentWiseData, (grades, studentId) => {
    _.forEach(grades, (currentGrade, index) => {
      const {
        grade,
        dataSource,
        school,
        academicYear,
        isHidden,
      } = currentGrade;

      added.push({
        studentId,
        gradeId: _.get(grade, "id"),
        dataSource,
        schoolId: _.get(school, "id"),
        academicYearId: _.get(academicYear, "id"),
        isHidden,
        displaySequence: index + 1,
      });
    });
  });

  return added;
};

export const buildGradeIdToMapIdLookup = records => {
  const gradeIdToGradeMapId = {};

  _.forEach(records, ({ id, grade, student }) => {
    const studentId = _.get(student, "id");
    const gradeId = _.get(grade, "id");

    gradeIdToGradeMapId[studentId] = gradeIdToGradeMapId[studentId] || {};
    gradeIdToGradeMapId[studentId][gradeId] = id;
  });

  return gradeIdToGradeMapId;
};

export const buildGradingPeriodMappings = ({
  studentWiseData,
  gradeIdToGradeMapId,
}) => {
  const addedGradingPeriods = [];
  const removedGradingPeriods = [];

  _.forEach(studentWiseData, (grades, studentId) => {
    _.forEach(grades, currentGrade => {
      const { grade, gradingPeriods, originalGradingPeriods } = currentGrade;
      const gradeId = _.get(grade, "id");
      const studentGradeMapId = _.get(gradeIdToGradeMapId, [
        studentId,
        gradeId,
      ]);

      const originalGradingPeriodIds = _.map(
        originalGradingPeriods,
        "gradingPeriod.id"
      );
      const currentGradingPeriodIds = _.map(gradingPeriods, "gradingPeriod.id");

      const removedGradingPeriodIds = _.difference(
        originalGradingPeriodIds,
        currentGradingPeriodIds
      );

      _.forEach(currentGradingPeriodIds, (gradingPeriodId, index) => {
        addedGradingPeriods.push({
          studentGradeMapId,
          gradingPeriodId,
          displaySequence: index + 1,
        });
      });

      _.forEach(removedGradingPeriodIds, gradingPeriodId => {
        removedGradingPeriods.push({
          studentGradeMapId,
          gradingPeriodId,
        });
      });
    });
  });

  return { addedGradingPeriods, removedGradingPeriods };
};
